import React from "react";
import { Link } from "react-router-dom";
import renderSelectField from "shared/components/form/Select";
import { formatCurrencyValue, stringToMask } from "helpers/string";
import { Button, Col, Container, Row, Spinner } from "reactstrap";
import { Field, reduxForm } from "redux-form";
import Input from "components/ReduxForm/Input";
import { DATE } from "components/NumberFormat";
import TextArea from "components/ReduxForm/TextArea";
import "./style.css";
import { BorderButton } from "./styles";
import validate from "./validate";
import { TextInput } from "components/TextInput";
import { PRIORITY_OPTIONS } from "types/contractSolicitation";

const NewSolicitationContractForm = ({
	isInvalid,
	loading,
	errors,
	submitting,

	onChangeFile,
	onChangeRadio,

	value,
	setValue,
	file,
	meis, //contratantes
	hireds, //prestadores,
	contracts, //contratos

	onSelectMei,
	onSearchMei,
	onSelectHired,
	onSearchHired,
	onSelectContractReference,
	onSearchContractReference,
	typeData,

	handleSubmit
}) => {
	return (
		<form className="form" onSubmit={handleSubmit}>
			<Container className="px-0">
				<Row>
					<Col className="form__form-group">
						<span className="bold-text">Contratante*</span>
						<div className="form__form-group-field">
							<Field
								name="hirer"
								component={renderSelectField}
								type="text"
								placeholder="Buscar contratante"
								onChange={mei => onSelectMei(mei)}
								onInputChange={meiSearch => onSearchMei(meiSearch)}
								options={[
									...meis.map(c => ({
										value: c._id,
										label: `${c.businessName}${
											c?.cnpj
												? " - CNPJ: " +
												  stringToMask(c?.cnpj, "##.###.###/####-##")
												: ""
										} - ID: ${c._id}`
									}))
								]}
								props={{ errors: errors && errors.hirer }}
							/>
						</div>
					</Col>
				</Row>
				<Row>
					<Col className="form__form-group">
						<span className="bold-text">Prestador*</span>
						<div className="form__form-group-field">
							<Field
								name="hired"
								component={renderSelectField}
								type="text"
								placeholder="Buscar prestador"
								onChange={hired => onSelectHired(hired)}
								onInputChange={hiredSearch => onSearchHired(hiredSearch)}
								options={
									hireds?.length
										? [
												...hireds.map(c => ({
													value: c._id,
													label: `${c.businessName}${
														c?.cnpj
															? " - CNPJ: " +
															  stringToMask(c?.cnpj, "##.###.###/####-##")
															: ""
													} - ID: ${c._id}`
												}))
										  ]
										: undefined
								}
								props={{ errors: errors && errors.hired }}
							/>
						</div>
					</Col>
				</Row>
				<Row>
					<Col xs={12} sm={12} md={6} xl={6} className="form__form-group">
						<span className="bold-text">Prioridade</span>
						<div className="form__form-group-field">
							<Field
								name="priority"
								component={renderSelectField}
								type="text"
								placeholder="Selecione uma prioridade"
								options={PRIORITY_OPTIONS}
								props={{ errors: errors && errors.priority }}
							/>
						</div>
					</Col>
					<Col xs={12} sm={12} md={6} xl={6} className="form__form-group">
						<span className="bold-text">Tier</span>
						<div className="form__form-group-field">
							<Field
								name="tier"
								component={renderSelectField}
								type="text"
								placeholder="Selecione um tier"
								options={[
									{ label: "High", value: "high" },
									{ label: "Mid", value: "mid" },
									{ label: "Low", value: "low" }
								]}
								props={{ errors: errors && errors.tier }}
							/>
						</div>
					</Col>
				</Row>
				<Row>
					<Col className="form__form-group">
						<span className="bold-text">Tipo de contrato*</span>
						<div className="form__form-group-field">
							<Field
								name="contractType"
								component={renderSelectField}
								type="text"
								placeholder="Selecione um tipo"
								options={typeData}
								props={{ errors: errors && errors.contractType }}
							/>
						</div>
					</Col>
				</Row>
				<Row>
					<Col className="form__form-group">
						<span className="bold-text">Função*</span>
						<div className="form__form-group-field">
							<Field
								name="role"
								component={Input}
								placeholder="Ex. programador visual"
								props={{ errors: errors && errors.role }}
							/>
						</div>
					</Col>
				</Row>
				<Row>
					<Col className="form__form-group">
						<span className="bold-text">Contrato de referência (opcional)</span>
						<div className="form__form-group-field">
							<Field
								name="contractReference"
								component={renderSelectField}
								type="text"
								placeholder="Buscar um contrato utilizado anteriormente para ser usado de referência"
								onChange={contract => onSelectContractReference(contract)}
								onInputChange={contractSearch =>
									onSearchContractReference(contractSearch)
								}
								options={[
									...contracts.map(c => ({
										value: c._id,
										label: `${c.template.name} - ID: ${c._id}`
									}))
								]}
								props={{ errors: errors && errors.contractReference }}
							/>
						</div>
					</Col>
				</Row>
				<Row>
					<Col className="form__form-group">
						<span className="bold-text">Atividades realizadas*</span>
						<div className="form__form-group-field">
							<Field
								name="activitiesDescription"
								component={TextArea}
								placeholder="Descreva a(s) atividade(s) realizada(s)  pela função"
								props={{ errors: errors && errors.activitiesDescription }}
							/>
						</div>
					</Col>
				</Row>
				<Row className="mb-2">
					<Col>
						<fieldset className="modality-fieldset">
							<legend className="bold-text">Modalidade*</legend>

							<div className="radio-options-container">
								<div className="radio-option">
									<input
										type="radio"
										id="hibrido"
										name="modality"
										className="radio-input"
										defaultChecked={true}
										onChange={onChangeRadio}
										value={"hybrid"}
									/>
									<label htmlFor="hibrido" className="radio-label">
										Híbrido
									</label>
								</div>

								<div className="radio-option">
									<input
										type="radio"
										id="presencial"
										name="modality"
										className="radio-input"
										onChange={onChangeRadio}
										value={"onsite"}
									/>
									<label htmlFor="presencial" className="radio-label">
										Presencial
									</label>
								</div>

								<div className="radio-option">
									<input
										type="radio"
										id="homeoffice"
										name="modality"
										className="radio-input"
										onChange={onChangeRadio}
										value={"remote"}
									/>
									<label htmlFor="homeoffice" className="radio-label">
										Home Office
									</label>
								</div>
							</div>
						</fieldset>
					</Col>
				</Row>
				<Row>
					<Col className="form__form-group">
						<span className="bold-text">Remuneração*</span>
						<div className="form__form-group-field">
							<TextInput
								placeholder="Ex: R$ 1.000,00"
								value={formatCurrencyValue(value)}
								onChange={e => {
									const newValue = Number(e.target.value.replace(/\D/g, ""));
									setValue(newValue);
								}}
							/>
						</div>
					</Col>
				</Row>
				<Row>
					<Col className="form__form-group">
						<span className="bold-text">Data do pagamento*</span>
						<div className="form__form-group-field">
							<Field
								name="paymentDate"
								component={Input}
								placeholder="Ex: Todo dia 5 do mês"
								props={{ errors: errors && errors.paymentDate }}
							/>
						</div>
					</Col>
				</Row>
				<Row>
					<Col xs={12} sm={12} md={6} xl={6} className="form__form-group">
						<span className="bold-text">Vigência (em meses)*</span>
						<div className="form__form-group-field">
							<Field
								name="lifespan"
								component={Input}
								placeholder="Ex: 12"
								type="number"
								min={0}
								max={999}
								props={{ errors: errors && errors.lifespan }}
							/>
						</div>
					</Col>
					<Col xs={12} sm={12} md={6} xl={6} className="form__form-group">
						<span className="bold-text">Data de início*</span>
						<div className="form__form-group-field">
							<Field
								name="startDate"
								component={DATE}
								type="text"
								placeholder="Ex.: 01/01/1970"
								props={{ errors: errors && errors.startDate }}
							/>
						</div>
					</Col>
				</Row>
				<Row>
					<Col className="form__form-group">
						<p className="bold-text">
							Possui algum contrato pré-existente? (opcional)
						</p>
						<Input
							accept="application/pdf"
							type="file"
							name="file"
							id="file-upload"
							className="upload-input"
							onChange={f => onChangeFile(f.target.files[0])}
						/>

						<label htmlFor="file-upload" className="custom-upload-button">
							<svg
								className="upload-icon"
								xmlns="http://www.w3.org/2000/svg"
								fill="none"
								viewBox="0 0 24 24"
								stroke="currentColor"
							>
								<path
									strokeLinecap="round"
									strokeLinejoin="round"
									d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-8l-4-4m0 0L8 8m4-4v12"
								/>
							</svg>
							<span>
								{file
									? `${
											file.name.length > 15
												? `${file.name.substring(
														0,
														10
												  )}...${file.name.substring(
														file.name.length - 4,
														file.name.length
												  )}`
												: file.name
									  }`
									: "Upload"}
							</span>
						</label>
					</Col>
				</Row>
				<Row>
					<Col className="form__form-group">
						<span className="bold-text">
							Cláusulas e informações adicionais (opcional)
						</span>
						<div className="form__form-group-field">
							<Field
								name="additionalInformation"
								component={TextArea}
								placeholder="Descreva em tópicos"
								props={{ errors: errors && errors.additionalInformation }}
							/>
						</div>
					</Col>
				</Row>
				<Row>
					<Col className="text-right">
						<Link to="/contracts/contract-solicitation-selection">
							<BorderButton className="btn btn-lg">Voltar</BorderButton>
						</Link>
						<Button
							className="ml-2"
							color="primary"
							type="submit"
							disabled={submitting || isInvalid || loading.new}
						>
							{loading.new ? (
								<Spinner type="grow" size="sm" color="dark" />
							) : (
								"Solicitar"
							)}
						</Button>
					</Col>
				</Row>
			</Container>
		</form>
	);
};

export default reduxForm({
	form: "solicitation_contract_create",
	validate
})(NewSolicitationContractForm);
